import { useRequest } from "hooks";
import type { ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { WaMessagesResponse } from "../types";
import { getWaMessagesThunk } from "../thunks";
import { changeExportWaMessagesLoading as changeExportLoading } from "../slice";

export const useWaMessagesActions = () => {
    const getWaMessages = useRequest<
        ThunkReturnType<WaMessagesResponse>,
        string | undefined
    >({
        thunk: getWaMessagesThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetWaMessages
    });

    return {
        getWaMessages,
        downloadCsv
    };
};

export default useWaMessagesActions;
